var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("שיוך ליחידות לימוד"),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body", staticStyle: { height: "500px" } },
        [
          _c(
            "div",
            { staticClass: "DialogReportPaid__Component__Loading" },
            [
              _c(
                "b-field",
                { attrs: { label: "בחר יחידות לימוד" } },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        dir: "rtl",
                        label: "Text",
                        options: _vm.lessons,
                        clearable: true,
                        multiple: true,
                        searchable: true,
                        "close-on-select": false,
                        placeholder: "בחר ערך מהרשימה",
                      },
                      model: {
                        value: _vm.lessonIds,
                        callback: function ($$v) {
                          _vm.lessonIds = $$v
                        },
                        expression: "lessonIds",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("לא נמצאו ערכים דומים")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }